module.exports = __webpack_public_path__ + "45043ed59df5f70cdc8c14fa18d759d7.svg";